"use client";

import Link from "next/link";

function SocialIcon({ platform, className = "h-3.5 w-3.5" }: { platform: string; className?: string }) {
  const lower = platform.toLowerCase();
  if (lower === "instagram") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  return null;
}

export function EventFooter() {
  return (
    <footer className="mx-auto max-w-[1200px] px-7 pt-12 pb-36 border-t border-white/[0.08]">
      <div className="flex justify-between items-start gap-8 flex-wrap">
        <div>
          <p className="text-sm font-semibold text-white">Hopp</p>
          <p className="mt-2 text-xs text-white/50 max-w-[280px]">Curated events for your circle. We are not responsible for host cancellations.</p>
          <div className="flex gap-3 mt-4">
            <a href="https://instagram.com/hopp.co.in" target="_blank" rel="noreferrer" aria-label="Hopp on Instagram" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/[0.08] text-white/50 hover:text-white hover:border-white/[0.12] transition">
              <SocialIcon platform="instagram" className="h-3.5 w-3.5" />
            </a>
            <a href="mailto:info@hopp.life" aria-label="Email Hopp" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/[0.08] text-white/50 hover:text-white hover:border-white/[0.12] transition">
              <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
            </a>
          </div>
        </div>
        <div className="flex gap-12">
          <div className="flex flex-col gap-2">
            <span className="text-[11px] uppercase tracking-[0.1em] font-semibold text-white/50 mb-1">Company</span>
            <Link href="/legal/terms" className="text-xs text-white/50 hover:text-white transition">Terms</Link>
            <Link href="/legal/privacy" className="text-xs text-white/50 hover:text-white transition">Privacy</Link>
            <Link href="/contact" className="text-xs text-white/50 hover:text-white transition">Contact</Link>
          </div>
        </div>
      </div>
      <div className="mt-8 pt-5 border-t border-white/[0.08] flex justify-between text-[11px] text-white/50">
        <span>&copy; {new Date().getFullYear()} Hopp</span>
        <span>Made for the culture</span>
      </div>
    </footer>
  );
}
